import { history } from 'store';

import { setTrackingContext, clearTrackingContext, isTrackedUser } from './context';
import { installLifecycleHandlers, flush } from './queue';
import { trackPv } from './track';
import { getSessionId } from './session';
import { initSubSession, installSsidLinkDecorator } from './subSession';
import { EUserType } from 'services/BackendApi';

const PV_PATHS = ['/search', '/booking-builder', '/pure-ai'];
const shouldTrackPv = (pathname: string) => PV_PATHS.some(p => pathname.startsWith(p));

let initialized = false;


export const initTrackingEvents = (identity: {
  email: string;
  country?: string | null;
  userType: EUserType;
  travelAgentId?: string | null;
}): void => {
  setTrackingContext(identity);

  if (!isTrackedUser()) return;

  // Session / sub-session bootstrap (idempotent on repeated calls).
  getSessionId();
  initSubSession();

  if (initialized) return;
  initialized = true;

  installSsidLinkDecorator();
  installLifecycleHandlers();

  if (shouldTrackPv(window.location.pathname)) {
    trackPv();
  }

  history.listen(() => {
    if (shouldTrackPv(window.location.pathname)) {
      trackPv();
    }
  });
};

export const resetTrackingEvents = (): void => {
  flush();
  clearTrackingContext();
};
